export function generateRandomString(length) {
  return [...Array(length)].join().replace(/(.|$)/g,  () => {
    return ((Math.random() * 36) | 0).toString(36)[Math.random() < .5 ? 'toString' : 'toUpperCase']();
  });
}
